import { Directive, ElementRef, Input, OnInit, HostListener, AfterViewInit } from '@angular/core';
/**
 * This directive will add a flex values for screen breakpoints.
 * sending a flex values are optional.
 * Pre-requisite is to have the direct parent with :
 *  1-display: flex
 *  2-flex-direction: row
 *  3-flex-wrap: wrap
 * 
 */
@Directive({
  selector: '[dynamicFlex]'
})
export class DynamicFlexDirective implements OnInit, AfterViewInit {

  element: HTMLElement;
  flexValues: any;
  windowWidth: number;

  @Input("dynamicFlex") set flexValue(value: string) {
    //called in timeout in case there are any fxFlex stuff on the same element which will override this directive work
    setTimeout(() => {
      this.generateFlexValues(value);
      this.setFlexInElement();
    });
  }

  constructor(el: ElementRef) {
    this.element = el.nativeElement as HTMLElement;
    this.windowWidth = window.innerWidth;
    this.element.style.boxSizing = "border-box";
  }

  ngAfterViewInit(): void {
    //called in ngAfterViewInit in case there are any fxFlex stuff on the same element which will override this directive work
    if (!this.flexValues) {//if flexValues are not given as an input then use default flexValues
      this.generateFlexValues("100|100|50|33.33|25");
      this.setFlexInElement();
    }
  }

  ngOnInit() {
  }

  //when screen sizes change generate new flex values for element
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.setFlexInElement();
  }


  generateFlexValues(value: string) {
    let valueArray = value.split("|");
    this.flexValues = {};
    for (let i = 0; i < valueArray.length; i++) {
      let amount = valueArray[i];
      switch (i) {
        case 0:
          this.flexValues["xs"] = amount;
          break;
        case 1:
          this.flexValues["sm"] = amount;
          break;
        case 2:
          this.flexValues["md"] = amount;
          break;
        case 3:
          this.flexValues["lg"] = amount;
          break;
        case 4:
          this.flexValues["xl"] = amount;
          break;
      }
    }
  }

  setFlexInElement() {
    let breakpoint = this.getBreakpointType();
    //add box-sizing: border-box;
    this.element.style.flex = "1 1 " + this.flexValues[breakpoint] + "%";
    this.element.style.maxWidth = this.flexValues[breakpoint] + "%";
  }

  getBreakpointType(): string {
    if (this.windowWidth >= 1200) {
      return "xl";
    } else if (this.windowWidth >= 992) {
      return "lg";
    } else if (this.windowWidth >= 768) {
      return "md";
    } else if (this.windowWidth >= 576) {
      return "sm";
    } else {
      return "xs";
    }
  }

}
